import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../user/component/updateProfile.scss';
import PaymentIcon from "../../../images/pay.png";
import PaymentIconActive from "../../../images/pay-active.png";
import ProfileIcon from "../../../images/profile-icon.png";
import ProfileIconActive from "../../../images/profile-icon-active.png";
import CreditIcon from "../../../images/pay (1).png";
import CreditIconActive from "../../../images/credit-icon-active.png";
import ShareIcon from "../../../images/share.png";
import ShareIconActive from "../../../images/share-active.png";
import ResetIcon from "../../../images/password.png";
import ResetIconActive from "../../../images/password-active.png";
import LogoutIcon from "../../../images/logout.png";
import LogoutIconActive from "../../../images/logout-active.png";
import Header from "../../../layout/DefaultLayout/Header";
import Avatar from "../../../images/img_avatar.png";
import { getUserDetailsByID, getUserDetails } from '../../user/action/user.actions'
import ResetPassword from '../../user/component/resetPassword';
import Credits from '../../user/component/credits';
import UpdatePofile from '../../user/component/updatePofile';
import { logout } from '../../user/action/user.actions'
import { fromValidate, history } from '../../../helpers'

class UserApproval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: 'Profile',
            data:{}
        }
    }

    componentDidMount() {
        this.getUsersData()   
    }
    getUsersData(){
        const { dispatch, user } = this.props;
        const userId = (this.props && this.props.location) ? this.props.location.state.detail : ''
        if(userId != ''){
            dispatch(getUserDetailsByID(userId)).then( (res)=>{
                this.setState({data: res.data})
            })
        }else{
            dispatch(getUserDetails(userId))
        }   
    }
    onChangeMenu = (menu) => {
        this.setState({ menu: menu })
    }

    logout = (e) => {
        const { dispatch } = this.props;
        dispatch(logout())
        console.log("Logging out")
        history.push('/')
    }

    render() {
        const { user } = this.props;
        const { menu, data } = this.state;
        return (
            <div>
                <Header></Header>
                <div className='profile-container'>
                    <div className='profile-box'>
						<div>
							<div className="profile-image">
								<img src={Avatar} className="team-member-image" alt="" />
							</div>
							<div className="name-txt">{data.first_name} {data.last_name}</div>	
						</div>
						<hr></hr>
						<div>
							`{
								menu == 'Profile' &&
								<UpdatePofile userDetails = {this.state.data}></UpdatePofile>
							}
							{
								menu == 'ResetPassword' &&
								<ResetPassword></ResetPassword>
							}
							{
								menu == 'Credits' &&
								<Credits></Credits> 

							}`
						</div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
    }
}
export default connect(mapStateToProps)(UserApproval);